import dayjs from '@sancare/typescript-commons/src/misc/dayjs'

import { formatBaseStay, formatCodedMedicalActs } from '@/misc/stay/helper'
import { RawRhs, RawSmrStay, Rhs, SmrStay } from '@/store/modules/stay/smr/types'

export function formatSmrStay(rawStay: RawSmrStay): SmrStay {
  // TODO: Common formatter with MCO stays
  return {
    ...formatBaseStay(rawStay),
    smrId: rawStay.smrId,
    hospitalizationType: rawStay.hospitalizationType,
    rhsList: formatRhsList(rawStay.rhsList),
    firstStandardModeGroupingResult: rawStay.firstStandardModeGroupingResult,
    standardModeGroupingResult: rawStay.standardModeGroupingResult,
    presenceDayCount: rawStay.presenceDayCount,
    surgeryDate: rawStay.surgeryDate ? dayjs(rawStay.surgeryDate) : null,
    validationDate: rawStay.validationDate ?? null,
    validationUser: rawStay.validationUser ?? null,
    staySuggestions: rawStay.staySuggestions,
  }
}

export function formatRhsList(rawList: RawRhs[]): Rhs[] {
  const formattedList: Rhs[] = []
  rawList.forEach((rawRhs) => {
    formattedList.push(formatRhs(rawRhs))
  })
  return formattedList
}

export function formatRhs(rawRhs: RawRhs): Rhs {
  return {
    id: rawRhs.id,
    codedMedicalActs: formatCodedMedicalActs(rawRhs.codedMedicalActs),
    predictedLabels: rawRhs.predictedLabels,
    medicalUnit: rawRhs.medicalUnit,
    week: {
      nb: Number(rawRhs.weekNb.substring(0, 2)),
      year: Number(rawRhs.weekNb.substring(2))
    },
    weekDays: rawRhs.weekDays,
    weekEndDays: rawRhs.weekEndDays,
    endDate: dayjs(rawRhs.endDate),
    startDate: dayjs(rawRhs.startDate),
    currentDepDressing: rawRhs.currentDepDressing,
    currentDepMoving: rawRhs.currentDepMoving,
    currentDepFeeding: rawRhs.currentDepFeeding,
    currentDepContinence: rawRhs.currentDepContinence,
    currentDepBehaviour: rawRhs.currentDepBehaviour,
    currentDepSocial: rawRhs.currentDepSocial,
    initialModeDiagnosisGroup: rawRhs.initialModeDiagnosisGroup,
    currentModeDiagnosisGroup: rawRhs.currentModeDiagnosisGroup,
    codedRehabilitationActs: rawRhs.codedRehabilitationActs,
    admissionMode: rawRhs.admissionMode,
    releaseMode: rawRhs.releaseMode,
    origin: rawRhs.origin,
    destination: rawRhs.destination,
  }
}
